import React, { useState, useRef } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { useBreakpoint } from '../../../../util/Breakpoint.context';
import Icon from '../../../Icons/Icon';
import RemoveScroll from '../../../RemoveScroll/RemoveScroll';
import { useConstructorIO } from '../../../../util/ConstructorIO.context';
import ProductCard from '../../../ProductCard/ProductCard';
import { GET_USER_LOCALE } from '../../../App.gql';
import * as Styled from './SearchFlyout.styled';
import LinkText from '../../../LinkText/LinkText';
var hashSearch = function (searchTerm) {
    var cleanSearch = searchTerm.replace(/[^a-zA-Z0-9 ]/g, '');
    return btoa(cleanSearch);
};
/**
 * SearchFlyout Component
 */
var SearchFlyout = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var onBackdropClick = _a.onBackdropClick;
    var router = useRouter();
    var _h = useConstructorIO(), query = _h.query, results = _h.results, response = _h.response, recommendations = _h.recommendations;
    var positionRef = useRef(null);
    var wrapperPositionRef = useRef(null);
    var _j = useState(0), positionFromTop = _j[0], setPositionFromTop = _j[1];
    var hashedSearch = query ? hashSearch(query) : '';
    var _k = useBreakpoint(), medium = _k.medium, large = _k.large;
    var data = useQuery(GET_USER_LOCALE).data;
    var userCountry = (_c = (_b = data === null || data === void 0 ? void 0 : data.user) === null || _b === void 0 ? void 0 : _b.locale) === null || _c === void 0 ? void 0 : _c.country;
    var getPositionFromTop = function () {
        if (positionRef.current) {
            var top_1 = positionRef.current.getBoundingClientRect().top;
            setPositionFromTop(top_1);
        }
    };
    var handleButtonClick = function (e) {
        e.preventDefault();
        var path = e.currentTarget.getAttribute('href');
        if (path)
            router.push(path);
    };
    var resultsPerPage = medium && !large ? 3 : 4;
    var recommendationsPerPage = medium ? 4 : 3;
    var isSearchQueryEmpty = query.length > 0;
    var prefixDataLabel = isSearchQueryEmpty ? 'autocompleteSearchFlyout' : 'emptySearchFlyout';
    return (React.createElement(RemoveScroll, null,
        React.createElement(Styled.SearchFlyout, null,
            React.createElement(Styled.SearchFlyoutFloat, null,
                React.createElement(Styled.SearchFlyoutWrapper, { ref: wrapperPositionRef, positionFromTop: ((_d = wrapperPositionRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().top) || 0 },
                    React.createElement(Styled.RecommendationResults, { "data-label": prefixDataLabel },
                        React.createElement(Styled.RecommendationTitle, null, "Top Suggestions"),
                        React.createElement(Styled.Recommendations, null, recommendations && recommendations.slice(0, recommendationsPerPage).map(function (item) { return (React.createElement(LinkText, { size: "Regular", href: "/search?q=".concat(hashSearch(item.value)), icon: React.createElement(Icon, { name: "arrow-right", size: "mini" }) }, item.value)); }))),
                    React.createElement(Styled.Layout, { "data-label": query.length > 0 ? 'autocompleteSearchFlyout' : 'emptySearchFlyout', ref: positionRef, onTouchStart: getPositionFromTop, onMouseOver: getPositionFromTop, positionFromTop: positionFromTop }, results.length ? (React.createElement(React.Fragment, null,
                        (results.slice(0, resultsPerPage)).map(function (item, index) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                            return (React.createElement(Styled.Emboss, { key: index },
                                React.createElement(ProductCard, { title: item.value, dataLabel: "".concat(prefixDataLabel, "__productCard").concat(index + 1), images: [
                                        {
                                            id: (_a = item.data) === null || _a === void 0 ? void 0 : _a.id,
                                            src: (_b = item.data) === null || _b === void 0 ? void 0 : _b.image_url,
                                            alt: item.value
                                        }
                                    ], price: userCountry === 'US'
                                        ? {
                                            basePrice: (_d = (_c = item.data) === null || _c === void 0 ? void 0 : _c.base_price) === null || _d === void 0 ? void 0 : _d.toFixed(2),
                                            discountPrice: (_f = (_e = item.data) === null || _e === void 0 ? void 0 : _e.discount_price) === null || _f === void 0 ? void 0 : _f.toFixed(2),
                                            percentOff: (_g = item.data) === null || _g === void 0 ? void 0 : _g.percent_off,
                                            currency: 'USD'
                                        }
                                        : undefined, url: (_h = item.data) === null || _h === void 0 ? void 0 : _h.url, onClick: handleButtonClick, shopifyId: (_j = item.data) === null || _j === void 0 ? void 0 : _j.id })));
                        }),
                        isSearchQueryEmpty &&
                            (React.createElement(Styled.ButtonContainer, null,
                                React.createElement(Styled.AllResultsButton
                                // @ts-ignore
                                , { 
                                    // @ts-ignore
                                    href: "/search?q=".concat(hashedSearch), onClick: handleButtonClick, "data-cnstrc-search-submit-btn": true, "data-label": 'CTA' },
                                    "See All Results (", "".concat(((_e = response === null || response === void 0 ? void 0 : response.total_num_results_per_section) === null || _e === void 0 ? void 0 : _e.Products) >= 500
                                    ? '500+'
                                    : (_g = (_f = response === null || response === void 0 ? void 0 : response.total_num_results_per_section) === null || _f === void 0 ? void 0 : _f.Products) !== null && _g !== void 0 ? _g : 0),
                                    ")"))))) : (React.createElement(Styled.NoResultsContainer, null, isSearchQueryEmpty ? (React.createElement("p", null,
                        "No results for \"",
                        React.createElement(Styled.Bold, null, query),
                        "\"")) : (React.createElement("p", null, "No results"))))))),
            React.createElement(Styled.Backdrop, { onClick: onBackdropClick }))));
};
export default SearchFlyout;
